<div style="margin-top: 40px" class="container">
  <div class="confirm-identity-container row justify-content-center">
    <div class="col-md-6">
      <h2 class="text-center">Confirm your identity</h2>

      <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>

      <form
        id="shortLinkVerificationForm"
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
        class="mt-4"
        *ngIf="loginForm">

          <div class="form-group">
            <label for="Email">
              Enter email address that matches this pattern: {{ maskedEmail }}
            </label>
            <input
              id="Email"
              type="email"
              [formControl]="loginFormControls.email"
              [maxlength]="maxEmailLength"
              [attr.disabled]="isLoading ? '' : null"
              class="form-control"
              [class.is-invalid]="loginFormControls.email.invalid && (loginFormControls.email.dirty || loginFormControls.email.touched)">
            <span
              *ngIf="loginFormControls.email.invalid && (loginFormControls.email.dirty || loginFormControls.email.touched)"
              class="text-danger">
              <span *ngIf="loginFormControls.email.errors?.['email']">Please enter a valid email address.</span>
            </span>
          </div>

          <div class="form-group mt-3">
            <label for="Phone">
              Or, enter phone number which ends in {{ maskedPhone }}
            </label>
            <input
              id="Phone"
              type="tel"
              [formControl]="loginFormControls.phoneNumber"
              [maxlength]="maxPhoneLength"
              [attr.disabled]="isLoading ? '' : null"
              class="form-control"
              [class.is-invalid]="loginFormControls.phoneNumber.invalid && (loginFormControls.phoneNumber.dirty || loginFormControls.phoneNumber.touched)">
            <span
              *ngIf="loginFormControls.phoneNumber.invalid && (loginFormControls.phoneNumber.dirty || loginFormControls.phoneNumber.touched)"
              class="text-danger">
            </span>
          </div>

          <div class="text-center mt-4">
            <button
              id="shortLinkVerifyButton"
              type="submit"
              class="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2"
              [disabled]="isLoading">
              <span>{{ isLoading ? 'Validating...' : 'Validate and Continue' }}</span>
              <span class="spinner" *ngIf="isLoading" aria-hidden="true">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </span>
            </button>
          </div>

          <div #turnstileContainer class="d-flex justify-content-center mt-4"></div>
        </form>
    </div>
  </div>
</div>
